import { useSearchParams } from "react-router-dom";

export const useRoute = <T extends {}>(): T => {
  const [searchParams] = useSearchParams();
  const params = Object.fromEntries(searchParams.entries());

  return { params } as unknown as T;
};
